import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";

import type { Service } from "@mirage/service-url-metadata/service";

const service = services.get<Service>(ServiceId.URL_METADATA);

export const metadataForUrls = service.metadataForUrls;
